(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('ModalConfirmController', ModalConfirmController);

    ModalConfirmController.$inject = ['$scope', '$uibModalInstance', 'confirmMessage', 'confirmTitle', 'confirmCaption', 'cancelCaption', 'buttonClass', 'iconClass', 'cancelButtonClass', 'cancelIconClass'];

    function ModalConfirmController($scope, $uibModalInstance, confirmMessage, confirmTitle, confirmCaption, cancelCaption, buttonClass, iconClass, cancelButtonClass, cancelIconClass) {
        $scope.confirmMessage = confirmMessage;
        $scope.confirmTitle = confirmTitle;
        $scope.confirmCaption = confirmCaption;
        $scope.cancelCaption = cancelCaption;
        $scope.buttonClass = buttonClass ? buttonClass : 'btn-primary';
        $scope.iconClass = iconClass ? iconClass : 'fa-check';
        $scope.cancelButtonClass = cancelButtonClass ? cancelButtonClass : 'btn-primary';
        $scope.cancelIconClass = cancelIconClass ? cancelIconClass : 'fa-ban';

        $scope.ok = function () {
            $uibModalInstance.close();
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
